import {
  useAccountTags,
  useAddAccountTag,
  useRemoveAccountTag,
  useRenameAccountTag,
  useSetActiveAccountTags,
} from "@/api/hooks/account";
import { Tag } from "@/components/molecules/Tag/Tag";
import { TagGroupWithAdd } from "@/components/organisms/TagGroupWithAdd/TagGroupWithAdd";
import { WindowKind, instanceId, useDesktop } from "@/overlay/components/window";
import { useAppDispatch } from "@/reducer";
import { removeTagFromAllProfiles, renameTagInAllProfiles } from "@/reducer/ProfileState";
import { t } from "@lingui/core/macro";

export function DashboardTagFilter({ isSideNav = false }) {
  const addTagMutation = useAddAccountTag();
  const removeTagMutation = useRemoveAccountTag();
  const renameTagMutation = useRenameAccountTag();
  const setActiveTagsMutation = useSetActiveAccountTags();
  const desktop = useDesktop();
  const dispatch = useAppDispatch();
  const { tags, isLoading: tagsLoading } = useAccountTags();

  const handleToggleTag = (tag: string) => {
    const newActiveTags = tags.active?.includes(tag)
      ? tags.active?.filter((t) => t !== tag)
      : [...(tags.active || []), tag];
    setActiveTagsMutation.mutate(newActiveTags);
  };

  const handleRemoveTag = (tag: string) => {
    desktop.dispatch({
      type: "confirmationWindow",
      windowId: instanceId(WindowKind.ConfirmationWindow),
      customProps: {
        message: t`Do you really want to delete tag "${tag}"`,
        callback: (confirmed: boolean) => {
          if (!confirmed) {
            return;
          }

          removeTagMutation.mutate(tag, {
            onSuccess: () => {
              dispatch(removeTagFromAllProfiles(tag));
            },
          });
        },
      },
    });
  };

  return (
    <>
      {!tagsLoading && (
        <TagGroupWithAdd
          tags={(tags.available || []).map((tag) => (
            <Tag
              key={tag}
              label={tag}
              iconName={"delete"}
              isSelected={tags.active?.includes(tag)}
              onClick={() => handleToggleTag(tag)}
              onIconClick={() => handleRemoveTag(tag)}
              onRename={(newTag) =>
                renameTagMutation.mutate(
                  { oldTag: tag, newTag },
                  {
                    onSuccess: () => {
                      dispatch(renameTagInAllProfiles({ oldTag: tag, newTag }));
                    },
                  },
                )
              }
              isDestructive={true}
            />
          ))}
          onAdd={(tagName) => addTagMutation.mutate(tagName)}
          isAddAtEnd={false}
          isSideNav={isSideNav}
        />
      )}
    </>
  );
}
